export const CYPRESS_QA = 'qa'

// see https://docs.cypress.io/faq/questions/using-cypress-faq.html#Is-there-any-way-to-detect-if-my-app-is-running-under-Cypress
export default function isCypress() {
  return Boolean(window.Cypress)
}

export function getCypressEnv() {
  return isCypress() && window.Cypress.env('ENVIRONMENT')
}
